import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import classnames from 'classnames';

import { useContinue } from '@ezbobdev/ui-commons';

import MaterialButton from '../MaterialButton/MaterialButton';

const MaterialContinue = (props) => {
  const { children, color, className, disabled, size, type, variant, fullWidth, onClick, ...rest } = useContinue(
    props,
    MaterialContinue.displayName,
  );

  const testId = rest['data-testid'] ?? 'continue-button';

  return useMemo(
    () => (
      <MaterialButton
        {...rest}
        className={classnames(MaterialContinue.displayName, className)}
        size={size}
        type={type}
        disabled={disabled}
        variant={variant}
        fullWidth={fullWidth}
        color={color}
        onClick={onClick}
        data-testid={testId}
      >
        {children}
      </MaterialButton>
    ),
    [className, size, type, disabled, variant, fullWidth, color, onClick, children, testId],
  );
};

MaterialContinue.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,

  willValidate: PropTypes.func,
  shouldValidate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  didValidate: PropTypes.func,

  willCreateUser: PropTypes.func,
  shouldCreateUser: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  didCreateUser: PropTypes.func,

  willUpdate: PropTypes.func,
  shouldUpdate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  didUpdate: PropTypes.func,

  willQuote: PropTypes.func,
  shouldQuote: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  quoteFeeType: PropTypes.string,
  quoteRepaymentType: PropTypes.string,
  quotePolicy: PropTypes.oneOf(['V2', 'legacy']),
  didQuote: PropTypes.func,

  willDecision: PropTypes.func,
  shouldDecision: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  decisionPolicy: PropTypes.oneOf(['V2', 'legacy']),
  didDecision: PropTypes.func,

  willMoveToStep: PropTypes.func,
  shouldMoveToStep: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  didMoveToStep: PropTypes.func,

  didFailed: PropTypes.func,

  overrideCase: PropTypes.func,
  allowLoginOnSignup: PropTypes.bool,
  silentCreateUser: PropTypes.bool,
  materialButton: PropTypes.object,
};

MaterialContinue.displayName = 'MaterialContinue';

export default React.memo(MaterialContinue);
